import { useEffect, useState } from 'react';

/**
 * Debounce a fast-changing value before it reaches a server query. 300 ms
 * is the shared BO search contract (ADR-056) — mirrors the catalogue's URL
 * debounce (Spec §M3) so admin tables don't fire one PostgREST request per
 * keystroke.
 */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
  const [debounced, setDebounced] = useState(value);

  useEffect(() => {
    const id = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(id);
  }, [value, delayMs]);

  return debounced;
}
